<template>
  <div>
    <div style="position: relative">

      <div id="container" style="height:700px"></div>

    </div>
  </div>
</template>

<script>
import G6 from '@antv/g6';
import insertCss from 'insert-css';

export default {
  name: 'graphChar',
  props:['data'],
  data(){
    return {
      type_group: ['Cell', 'Structure', 'Organ', 'Manufacturing_method', 'organization', 'Crosslinker', 'Modification' ],
      graph: null
    }
  },
  watch:{
    data: {
      handler(val) {
        if (!!val.nodes)
          this.getData()
      },
      deep: true,
      immediate: true
    }
  },
  mounted(){

  },
  methods:{

    getData(){
      if (!!this.graph)
        this.graph.destroy()

      insertCss(`
        .g6-tooltip {
    border-radius: 6px;
    font-size: 12px;
    color: #393939;
    background-color: white;
    padding: 8px 8px;
    text-align: left;
    word-wrap: break-word;
    max-width: 600px;
    box-shadow: 0 0 8px 1px rgba(144,146,152,.4);
  }
  .g6-minimap{
      position: absolute;
    top: 0;
  }
    .g6-minimap-container {
    border: 1px solid #e2e2e2;
  }
  .g6-minimap-viewport {
    border: 2px solid rgb(25, 128, 255);
  }

   .g6-component-contextmenu {
    position: absolute;
    list-style-type: none;
    padding: 10px 8px;
    left: -150px;
    background-color: rgba(255, 255, 255, 0.9);
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    font-size: 12px;
    color: #545454;

  }
  .g6-component-contextmenu ul {
    margin: 0;
    padding: 0;
  }
  .g6-component-contextmenu li {
    cursor: pointer;
    list-style-type:none;
    list-style: none;
    margin-left: 0px;
    line-height: 25px;
    padding: 0 20px;
  }
  .g6-component-contextmenu li:hover {
    // color: #aaa;
    background: #f9f9f9;
  }
      `);

      const typeConfigs = {
        'Biomaterial': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#7ea5ff'
          }
        },
        'Paper': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#ff7900'
          }
        },
        'Cell': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#BDD2FD'
          }
        },
        'Structure': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#BDEFDB'
          }
        },
        'Organ': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#F6C3B7'
          }
        },
        'Manufacturing_method': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#FFD8B8'
          }
        },
        'organization': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#D3C6EA'
          }
        },
        'Crosslinker': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#B6E3F5'
          }
        },
        'Modification': {
          type: 'circle',
          size: 15,
          style: {
            fill: '#AAD8D8'
          }
        }
      }
      const legendData = {
        nodes: [
          {
            id: 'Biomaterial',
            label: 'Biomaterial',
            ...typeConfigs['Biomaterial']
          },
          {
            id: 'Paper',
            label: 'Paper',
            ...typeConfigs['Paper']
          },
          {
            id: 'Cell',
            label: 'Cell',
            ...typeConfigs['Cell']
          },
          {
            id: 'Structure',
            label: 'Structure',
            ...typeConfigs['Structure']
          },
          {
            id: 'Crosslinker',
            label: 'Crosslinker',
            ...typeConfigs['Crosslinker']
          },
          {
            id: 'Manufacturing_method',
            label: 'Manufacturing_method',
            ...typeConfigs['Manufacturing_method']
          },
          {
            id: 'organization',
            label: 'organization',
            ...typeConfigs['organization']
          },
          {
            id: 'Organ',
            label: 'Organ',
            ...typeConfigs['Organ']
          },
          {
            id: 'Modification',
            label: 'Modification',
            ...typeConfigs['Modification']
          }
        ],
        edges: [
        ]
      }
      const legend = new G6.Legend({
        data: legendData,
        align: 'center',
        layout: 'vertical', // vertical
        position: 'bottom-left',
        vertiSep: 4,
        horiSep: 0,
        offsetY: 0,
        padding: [16, 16, 16, 16],
        containerStyle: {
          fill: '#ffffff',
          stroke: '#ffffff',
          lineWidth: 1,

        },
        // title: 'Legend',
        // titleConfig: {
        //   position: 'center',
        //   offsetX: 0,
        //   offsetY: 12,
        // },

      });

      const contextMenu = new G6.Menu({
        getContent(evt) {

          return `
    <ul>
      <li>展开</li>
      <li>折叠</li>
    </ul>`;
        },
        handleMenuClick: (target, item) => {
          console.log(target, item);
        },
        // offsetX and offsetY include the padding of the parent container
        // 需要加上父级容器的 padding-left 16 与自身偏移量 10
        offsetX: 16 + 10,
        // 需要加上父级容器的 padding-top 24 、画布兄弟元素高度、与自身偏移量 10
        offsetY: 0,
        // the types of items that allow the menu show up
        // 在哪些类型的元素上响应
        itemTypes: ['node', 'edge', 'canvas'],
      });



      let mockData= {
        "nodes": [
          {
            "tier": 1,
            "name": "keratan sulfate",
            "id": "e44551854c7043480a9975513dacfa78",
            "type": "Biomaterial",
            size: 50
          },
          {
            "tier": 2,
            "zh_title": "Beta3Gn-T7 Is a Keratan Sulfate β1，3 <em>N</em>-Acetylglucosaminyltransferase in the Adult Brain",
            "year": "2022",
            "id": "8863611",
            "type": "Paper",
            "comboId": "Paper1",
            "authors": "Yoshiko Takeda-Uchimura;Kazuchika Nishitsuji;Midori Ikezaki;Tomoya O. Akama;Yoshito Ihara;Fabrice Allain;Kenji Uchimura"
          },
          {
            "tier": 2,
            "zh_title": "Plasma Proteomic Analysis in Morquio A Disease",
            "year": "2021",
            "id": "8201332",
            "type": "Paper",
            "comboId": "Paper1",
            "authors": "José V. Álvarez;Susana B. Bravo;María Pilar Chantada-Vázquez;Sofía Barbosa-Gouveia;Cristóbal Colón;Olalla López-Suarez;Shunji Tomatsu;Francisco J. Otero-Espinar;María L. Couce;Antonio Lucacchini;Emiliano González Vioque"
          },
          {
            "tier": 2,
            "zh_title": "Chondrogenic potential of mesenchymal stem cells from horses using a magnetic 3D cell culture system",
            "year": "2021",
            "id": "8246251",
            "type": "Paper",
            "comboId": "Paper1",
            "authors": "Joice Fülber;Fernanda R Agreste;Sarah R T Seidel;Eric D P Sotelo;Ângela P Barbosa;Yara M Michelacci;Raquel Y A Baccarin"
          },
          {
            "tier": 2,
            "zh_title": "Galectins and Their Ligand Glycoconjugates in the Central Nervous System Under Physiological and Pathological Conditions",
            "year": "2021",
            "id": "8554236",
            "type": "Paper",
            "comboId": "Paper1",
            "authors": "Junko Nio-Kobayashi;Tetsuya Itabashi"
          },
          {
            "tier": 2,
            "zh_title": "Integration of transcriptomic profile of SARS-CoV-2 infected normal human bronchial epithelial cells with metabolic and protein-protein interaction networks",
            "year": "2020",
            "id": "7314513",
            "type": "Paper",
            "comboId": "Paper1",
            "authors": "Hamza Umut KARAKURT;Pınar PİR"
          },
          {
            "tier": 2,
            "zh_title": "GlcNAc6ST3 is a keratan sulfate sulfotransferase for the protein-tyrosine phosphatase PTPRZ in the adult brain",
            "year": "2019",
            "id": "6416290",
            "type": "Paper",
            "comboId": "Paper1",
            "authors": "Narentuya;Yoshiko Takeda-Uchimura;Tahmina Foyez;Zui Zhang;Tomoya O. Akama;Hirokazu Yagi;Koichi Kato;Yukio Komatsu;Kenji Kadomatsu;Kenji Uchimura"
          },
          {
            "tier": 3,
            "name": ", ,",
            "id": "d41d8cd98f00b204e9800998ecf8427e",
            "type": "organization"
          },
          {
            "tier": 3,
            "name": "Brain",
            "id": "8b373710bcf876edd91f281e50ed58ab",
            "type": "Organ"
          },
          {
            "tier": 3,
            "name": "oligodendrocytes",
            "id": "fcaea3c9e9ea140fb0bd1ef722be3cc5",
            "type": "Cell"
          },
          {
            "tier": 3,
            "name": "neurons",
            "id": "7d874ae5832ba8e6bccd45bd7a543d67",
            "type": "Structure"
          },
          {
            "tier": 3,
            "name": "Department of Pharmacology, Pharmacy and Pharmaceutical Technology, School of Pharmacy, Campus Vida, University of Santiago de Compostela, 15872 Santiago de Compostela, Spain",
            "id": "34c8470256450dd9e9e0988f551d7d81",
            "type": "organization"
          },
          {
            "tier": 3,
            "name": "Health Research Institute of Santiago de Compostela (IDIS), CIBERER, MetabERN, 15706 Santiago de Compostela, Spain;",
            "id": "df3f9932632d0359a372df7cc863c26e",
            "type": "organization"
          },
          {
            "tier": 3,
            "name": "Proteomic Platform, Health Research Institute of Santiago de Compostela (IDIS), Hospital ClínicoUniversitario de Santiago de Compostela, 15706 Santiago de Compostela, Spain;(S.B.B.);(M.P.C.-V.)",
            "id": "9c64d255bbbfce09ec4de55a8bb90362",
            "type": "organization"
          },
          {
            "tier": 3,
            "name": "Paraquasil Platform, Health Research Institute of Santiago de Compostela (IDIS), Hospital Clínico Universitario de Santiago de Compostela, 15706 Santiago de Compostela, Spain",
            "id": "940e4be04eafdab4884e926c084dee27",
            "type": "organization"
          },
          {
            "tier": 3,
            "name": "Skeletal Dysplasia Lab Nemours Biomedical Research Nemours/Alfred I, duPont Hospital for Children, 1600 Rockland Road, Wilmington, DE 19803, USA;",
            "id": "f35efd029e9db7e16a63131992253d1d",
            "type": "organization"
          },
          {
            "tier": 3,
            "name": "Department of Forensic Sciences, Pathology, Gynecology and Obstetrics, Pediatrics, Neonatology Service, Health Research Institute of Santiago de Compostela (IDIS), Hospital Clínico Universitario de Santiago de Compostela, CIBERER, MetabERN, 15706 Santiago de Compostela, Spain or(J.V.Á.);(C.C.);(O.L.-S.)",
            "id": "60ace752a42dede7ab269f54f9de7929",
            "type": "organization"
          },
          {
            "tier": 3,
            "name": "Bone",
            "id": "a57fc812a9521b8c0ede9a2724351a55",
            "type": "Organ"
          },
          {
            "tier": 3,
            "name": "Chondrocytes",
            "id": "c42a63d23de7feccc4496772c659a47d",
            "type": "Cell"
          },
          {
            "tier": 3,
            "name": "Cartilage",
            "id": "ac60b83b965d0d4b8f85bd5d613d6dd9",
            "type": "Structure"
          },
          {
            "tier": 3,
            "name": "Phosphorylation",
            "id": "fe9546701d4f008db999ec518f3141d4",
            "type": "Modification"
          },
          {
            "tier": 3,
            "name": "astrocytes",
            "id": "952098a0566c4eefd03ba587a623ba30",
            "type": "Cell"
          },
          {
            "tier": 3,
            "name": "microglia",
            "id": "3222fef4c70ceb71adf716e95c4f5cf1",
            "type": "Cell"
          },
          {
            "tier": 3,
            "name": "Lung",
            "id": "2cf182cef6230c07c5206f027db2af4e",
            "type": "Organ"
          },
          {
            "tier": 3,
            "name": "Bronchial Epithelial Cells",
            "id": "5aadd8b58aa9ab1a4788610fe7139ecd",
            "type": "Cell"
          },
          {
            "tier": 3,
            "name": "Bronchi",
            "id": "ee950e8febb3a0bb66f2b2e3d8948e0d",
            "type": "Structure"
          },
          {
            "tier": 2,
            "name": "DOPA",
            "id": "2f3f19dcb593b5ed8e7b5d04f47ff28b",
            "type": "Modification"
          },
          {
            "tier": 2,
            "name": "Quaternized modification",
            "id": "d6f14cd45ea1a984e81b65e326bd1c61",
            "type": "Modification"
          },
          {
            "tier": 2,
            "name": "Oxidation",
            "id": "413f3a95ae27698164bdadf55b0bef8c",
            "type": "Modification"
          },
          {
            "tier": 2,
            "name": "Thiol functionalization",
            "id": "d430f1c081337ccceb85da58d60547ef",
            "type": "Modification"
          },
          {
            "tier": 2,
            "name": "Hofmann reaction",
            "id": "3b53b95b6927e2202ba648b711cb5282",
            "type": "Modification"
          },
          // {
          //   "tier": 2,
          //   "name": "Deacetylation",
          //   "id": "eb356653a899ec344224a0df6de10460",
          //   "type": "Modification"
          // },
          // {
          //   "tier": 2,
          //   "name": "Iodine modification",
          //   "id": "a047e501d83511f4eec3c00bfa977654",
          //   "type": "Modification"
          // },
          // {
          //   "tier": 2,
          //   "name": "Pentenoate functionalization",
          //   "id": "18c304140fc7aff38d889ff2d3d76216",
          //   "type": "Modification"
          // },
          // {
          //   "tier": 2,
          //   "name": "acetylation,",
          //   "id": "1333ea05e394cf13c4121cb4e89ebaa7",
          //   "type": "Modification"
          // },
          // {
          //   "tier": 2,
          //   "name": "TEMPO oxidation",
          //   "id": "841866e89ed93fc7c67e64cdd344c721",
          //   "type": "Modification"
          // },
          {
            "tier": 2,
            "name": "Primary human stellate cells",
            "id": "4bcbf2e8aab1a1eba23a58384a0f6f48",
            "type": "Cell"
          },
          {
            "tier": 2,
            "name": "Human hepatocellular carcinoma cell line 7",
            "id": "9fbd4bb7e2f7d9b70ddfb3309af77ee4",
            "type": "Cell"
          },
          {
            "tier": 2,
            "name": "National Institutes of Health 3T3 Cell Line",
            "id": "d3a43a7ad1c9c55a3df0261cc96d6c0d",
            "type": "Cell"
          },
          // {
          //   "tier": 2,
          //   "name": "Peripheral Blood Progenitor Cells",
          //   "id": "33af7b6a3d291dd694972a0ed266f843",
          //   "type": "Cell"
          // },
          // {
          //   "tier": 2,
          //   "name": "Tracheal Epithelial Cells",
          //   "id": "975a83faddcc1c680066b55ec18a7855",
          //   "type": "Cell"
          // },
          // {
          //   "tier": 2,
          //   "name": "Embryonic Neural Cells",
          //   "id": "34381e0578da34a2823217afd81eea42",
          //   "type": "Cell"
          // },
          // {
          //   "tier": 2,
          //   "name": "rat dermal fibroblasts",
          //   "id": "157f4411313d34d8c2c9588c6387458b",
          //   "type": "Cell"
          // },
          // {
          //   "tier": 2,
          //   "name": "Choroid Plexus Cells",
          //   "id": "396dfbf1dd7e850347739bf4d10e4933",
          //   "type": "Cell"
          // },
          // {
          //   "tier": 2,
          //   "name": "Neuroglial Cells",
          //   "id": "7171b0bf569387e5326e12d00b3ff705",
          //   "type": "Cell"
          // },
          // {
          //   "tier": 2,
          //   "name": "Insulin-Producing Cells",
          //   "id": "dfc740dd31ff7b41d3631b4774eb4a28",
          //   "type": "Cell"
          // },
          {
            "tier": 2,
            "name": "particle leaching",
            "id": "630d73c508798184dd0627e230eb01cb",
            "type": "Manufacturing_method"
          },
          {
            "tier": 2,
            "name": "Solvent casting",
            "id": "cd87d6fa196a4af68599d2d70e8f66e2",
            "type": "Manufacturing_method"
          },
          {
            "tier": 2,
            "name": "Droplet-based bioprinting",
            "id": "1b945ad3c5e72edf06c506eec287bb3e",
            "type": "Manufacturing_method"
          },
          {
            "tier": 2,
            "name": "acoustic bioprinting",
            "id": "d0c7526639a3750b1a5fbfc43b6a7ddd",
            "type": "Manufacturing_method"
          },
          // {
          //   "tier": 2,
          //   "name": "Mask-based photolithography.",
          //   "id": "74f162f039e6c1dc0cb2ad2792013824",
          //   "type": "Manufacturing_method"
          // },
          // {
          //   "tier": 2,
          //   "name": "Digital light processing ‐based printing",
          //   "id": "03a99ac802100724b0c926f5baf8ea9c",
          //   "type": "Manufacturing_method"
          // },
          // {
          //   "tier": 2,
          //   "name": "inkjet-based bioprinting",
          //   "id": "7714ba1f3023d07755f17faf141374ca",
          //   "type": "Manufacturing_method"
          // },
          // {
          //   "tier": 2,
          //   "name": "Extrusion-based bioprinting",
          //   "id": "5429f212a9c702980b3dcc8a986ffa7a",
          //   "type": "Manufacturing_method"
          // },
          // {
          //   "tier": 2,
          //   "name": "Multiphoton lithography[9]",
          //   "id": "b1341f1e4fdf992a532362982cb31fdb",
          //   "type": "Manufacturing_method"
          // },
          // {
          //   "tier": 2,
          //   "name": "Gas foaming",
          //   "id": "ff8d8694cdced28f7078e4633aac15f0",
          //   "type": "Manufacturing_method"
          // },
          {
            "tier": 2,
            "name": "Carbodiimide",
            "id": "c9fcef1d37f9a00320afd49b6b5b6334",
            "type": "Crosslinker"
          },
          {
            "tier": 2,
            "name": "Transglutaminase",
            "id": "0bf5691bc4da7c76142b6da2e0603e12",
            "type": "Crosslinker"
          },
          {
            "tier": 2,
            "name": "Epoxy",
            "id": "1b266d0e73ea5d2c6e9cf0f45b60861a",
            "type": "Crosslinker"
          },
          // {
          //   "tier": 2,
          //   "name": "Citric acid",
          //   "id": "450c26b988b881e61323897daadc25c0",
          //   "type": "Crosslinker"
          // },
          // {
          //   "tier": 2,
          //   "name": "tannic acid[2]",
          //   "id": "4049fd8ca0c5de3f3c3342f78c79c9e4",
          //   "type": "Crosslinker"
          // },
          // {
          //   "tier": 2,
          //   "name": "N,N′-methylene bisacrylamide",
          //   "id": "bf843bf32b0a02dce5b2e65f195fa332",
          //   "type": "Crosslinker"
          // },
          // {
          //   "tier": 2,
          //   "name": "Ethylene glycol diglycidyl ether",
          //   "id": "79ba77ecc5e393efe399582d2424a7c4",
          //   "type": "Crosslinker"
          // },
          // {
          //   "tier": 2,
          //   "name": "oxalic acid",
          //   "id": "dd83857f1a38b7f580db140b86970f66",
          //   "type": "Crosslinker"
          // },
          // {
          //   "tier": 2,
          //   "name": "thiourea formaldehyde resin[3]",
          //   "id": "c97fc46010cca31793807efd27ef4be4",
          //   "type": "Crosslinker"
          // },
          // {
          //   "tier": 2,
          //   "name": "aldehydes",
          //   "id": "b3fe559195ee83efbfbf65743e76a8a3",
          //   "type": "Crosslinker"
          // }
        ],
        "edges": [

          {
            "source": "7314513",
            "target": "2cf182cef6230c07c5206f027db2af4e"
          },
          {
            "source": "7314513",
            "target": "5aadd8b58aa9ab1a4788610fe7139ecd"
          },
          {
            "source": "7314513",
            "target": "ee950e8febb3a0bb66f2b2e3d8948e0d"
          },
          {
            "source": "8246251",
            "target": "fe9546701d4f008db999ec518f3141d4"
          },
          {
            "source": "8246251",
            "target": "952098a0566c4eefd03ba587a623ba30"
          },
          {
            "source": "8246251",
            "target": "3222fef4c70ceb71adf716e95c4f5cf1"
          },
          {
            "source": "8246251",
            "target": "a57fc812a9521b8c0ede9a2724351a55"
          },
          {
            "source": "8246251",
            "target": "c42a63d23de7feccc4496772c659a47d"
          },
          {
            "source": "8246251",
            "target": "ac60b83b965d0d4b8f85bd5d613d6dd9"
          },
          {
            "source": "8201332",
            "target": "34c8470256450dd9e9e0988f551d7d81"
          },
          {
            "source": "8201332",
            "target": "df3f9932632d0359a372df7cc863c26e"
          },
          {
            "source": "8201332",
            "target": "9c64d255bbbfce09ec4de55a8bb90362"
          },
          {
            "source": "8201332",
            "target": "940e4be04eafdab4884e926c084dee27"
          },
          {
            "source": "8201332",
            "target": "f35efd029e9db7e16a63131992253d1d"
          },
          {
            "source": "8201332",
            "target": "60ace752a42dede7ab269f54f9de7929"
          },
          {
            "source": "8201332",
            "target": "a57fc812a9521b8c0ede9a2724351a55"
          },
          {
            "source": "8201332",
            "target": "c42a63d23de7feccc4496772c659a47d"
          },
          {
            "source": "8201332",
            "target": "ac60b83b965d0d4b8f85bd5d613d6dd9"
          },

          {
            "source": "8554236",
            "target": "d41d8cd98f00b204e9800998ecf8427e"
          },
          {
            "source": "8863611",
            "target": "d41d8cd98f00b204e9800998ecf8427e"
          },
          {
            "source": "8863611",
            "target": "8b373710bcf876edd91f281e50ed58ab"
          },
          {
            "source": "8554236",
            "target": "8b373710bcf876edd91f281e50ed58ab"
          },
          {
            "source": "8863611",
            "target": "fcaea3c9e9ea140fb0bd1ef722be3cc5"
          },
          {
            "source": "8863611",
            "target": "7d874ae5832ba8e6bccd45bd7a543d67"
          },
          {
            "source": "8554236",
            "target": "7d874ae5832ba8e6bccd45bd7a543d67"
          },

          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "8863611"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "8201332"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "8246251"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "8554236"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "7314513"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "6416290"
          },
          {
            "source": "6416290",
            "target": "8b373710bcf876edd91f281e50ed58ab"
          },
          {
            "source": "6416290",
            "target": "fcaea3c9e9ea140fb0bd1ef722be3cc5"
          },
          {
            "source": "6416290",
            "target": "7d874ae5832ba8e6bccd45bd7a543d67"
          },


          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "2f3f19dcb593b5ed8e7b5d04f47ff28b"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "d6f14cd45ea1a984e81b65e326bd1c61"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "413f3a95ae27698164bdadf55b0bef8c"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "d430f1c081337ccceb85da58d60547ef"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "3b53b95b6927e2202ba648b711cb5282"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "eb356653a899ec344224a0df6de10460"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "a047e501d83511f4eec3c00bfa977654"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "18c304140fc7aff38d889ff2d3d76216"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "1333ea05e394cf13c4121cb4e89ebaa7"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "841866e89ed93fc7c67e64cdd344c721"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "4bcbf2e8aab1a1eba23a58384a0f6f48"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "9fbd4bb7e2f7d9b70ddfb3309af77ee4"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "d3a43a7ad1c9c55a3df0261cc96d6c0d"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "33af7b6a3d291dd694972a0ed266f843"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "975a83faddcc1c680066b55ec18a7855"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "34381e0578da34a2823217afd81eea42"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "157f4411313d34d8c2c9588c6387458b"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "396dfbf1dd7e850347739bf4d10e4933"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "7171b0bf569387e5326e12d00b3ff705"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "dfc740dd31ff7b41d3631b4774eb4a28"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "630d73c508798184dd0627e230eb01cb"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "cd87d6fa196a4af68599d2d70e8f66e2"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "1b945ad3c5e72edf06c506eec287bb3e"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "d0c7526639a3750b1a5fbfc43b6a7ddd"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "74f162f039e6c1dc0cb2ad2792013824"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "03a99ac802100724b0c926f5baf8ea9c"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "7714ba1f3023d07755f17faf141374ca"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "5429f212a9c702980b3dcc8a986ffa7a"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "b1341f1e4fdf992a532362982cb31fdb"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "ff8d8694cdced28f7078e4633aac15f0"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "c9fcef1d37f9a00320afd49b6b5b6334"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "0bf5691bc4da7c76142b6da2e0603e12"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "1b266d0e73ea5d2c6e9cf0f45b60861a"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "450c26b988b881e61323897daadc25c0"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "4049fd8ca0c5de3f3c3342f78c79c9e4"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "bf843bf32b0a02dce5b2e65f195fa332"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "79ba77ecc5e393efe399582d2424a7c4"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "dd83857f1a38b7f580db140b86970f66"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "c97fc46010cca31793807efd27ef4be4"
          },
          {
            "source": "e44551854c7043480a9975513dacfa78",
            "target": "b3fe559195ee83efbfbf65743e76a8a3"
          }
        ],
        // combos: [
        //   {
        //     id: 'Paper1',
        //     label: 'Paper',
        //   }
        // ],
      };

      const container = document.getElementById('container');
      let colorMap = {
        'Biomaterial': '#7ea5ff',
        'Cell': '#BDD2FD',
        'Structure': '#BDEFDB',
        'Organ': '#F6C3B7',
        'Manufacturing_method': '#FFD8B8',
        'organization': '#D3C6EA',
        'Crosslinker': '#B6E3F5',
        'Modification': '#AAD8D8',
        'Paper': '#ff7900',
      };
      const width = container.scrollWidth;
      const height = container.scrollHeight || 500;

      const minimap = new G6.Minimap({
        size: [150, 200],
      });

      this.graph = new G6.Graph({
        container: 'container',
        width,
        height,
        minZoom: 0.6,
        maxZoom: 2,
        layout: {
          type: 'force',
          preventOverlap: true,
          clustering: true,
          clusterNodeStrength: 50,
          clusterEdgeDistance: 50,
          clusterNodeSize: 50,
          clusterFociStrength: 1.2,
          nodeSpacing: 20,
          linkDistance: (d) => {
            if (d.source.id === 'e44551854c7043480a9975513dacfa78') {
              return 100;
            }
            return 30;
          },
          nodeStrength: (d) => {
            if (d.isLeaf) {
              return -50;
            }
            return -10;
          },
          edgeStrength: (d) => {
            if (d.source.id === 'node1' || d.source.id === 'node2' || d.source.id === 'node3') {
              return 0.7;
            }
            return 0.1;
          },

          // type: 'force',
          // clustering: true,
          // clusterNodeStrength: -5,
          // clusterEdgeDistance: 100,
          // clusterNodeSize: 20,
          // clusterFociStrength: 1.2,
          // nodeSpacing: 5,
          // preventOverlap: true,

          // type: 'dagre',
          // rankdir: 'LR',
          // align: 'DL',
          // nodesep: 30,
          // ranksep: 100,
          // controlPoints: true,
        },
        defaultNode: {
          size: 30,
          // type: "copy-node"
        },
        defaultEdge: {
          size: 1,
          color: '#e2e2e2',
          style: {
            endArrow: {
              path: 'M 0,0 L 8,4 L 8,-4 Z',
              fill: '#e2e2e2',
            },
          },
        },
        // nodeStateStyles: {
        //   selected: {
        //     stroke: '#d9d9d9',
        //     fill: '#5394ef',
        //   },
        // },
        // fitView: true,
        modes: {
          default: ['zoom-canvas', 'drag-canvas', 'drag-node',
            {
              type: 'tooltip',
              formatText(model) {
                if (!!model.name){
                  return model.name;
                }else {
                  const cfg = model;
                  const text = [];
                  text.push(cfg.zh_title+ '<br>');
                  text.push(cfg.year+ '<br>');
                  text.push(cfg.authors+ '<br>');
                  return text.join('\n');
                }

              },
              offset: 30,
            },
          ],
        },
        plugins: [minimap,legend,contextMenu]
      });
      this.data.nodes.forEach((i) => {
        if (i.type==='Biomaterial')
          i.size = 50;
        i.cluster = i.type;
        i.label = !!i.name?i.name.slice(0,30):i.zh_title.slice(0,30);
        i.style = Object.assign(i.style || {}, {
          fill: colorMap[i.type],
        });
      });


      this.graph.on("top-group:mouseenter", (e) => {
        this.graph.setItemState(e.item, "top-group-active", true);
      });
      this.graph.on("top-group:mouseleave", (e) => {
        this.graph.setItemState(e.item, "top-group-active", false);
      });
      this.graph.on("bottom-group:mouseenter", (e) => {
        this.graph.setItemState(e.item, "bottom-group-active", true);
      });
      this.graph.on("bottom-group:mouseleave", (e) => {
        this.graph.setItemState(e.item, "bottom-group-active", false);
      });
      this.graph.on("node:click", (e) => {
        const name = e.target.get("name");
        const model = e.item.get("model");
      });

      this.graph.data(this.data);
      this.graph.render();


      if (typeof window !== 'undefined')
        window.onresize = () => {
          if (!this.graph || this.graph.get('destroyed')) return;
          if (!container || !container.scrollWidth || !container.scrollHeight) return;
          this.graph.changeSize(container.scrollWidth, container.scrollHeight);
        };


    },
    refreshDragedNodePosition(e) {
      const model = e.item.get('model');
      model.fx = e.x;
      model.fy = e.y;
    },
    compare(prop) {
      return function(a, b) {
        return b[prop] - a[prop]  // 降序
        //  return a[prop] - b[prop]  // 升序
      }
    }
  },
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/carousel.css";
@import "../../../assets/css/bootstrap.min.css";

</style>



// WEBPACK FOOTER //
// src/pages/materials/modules/graphChar.vue